import { render, staticRenderFns } from "./ClassesModal.vue?vue&type=template&id=0486a2e6&scoped=true"
import script from "./ClassesModal.vue?vue&type=script&lang=js"
export * from "./ClassesModal.vue?vue&type=script&lang=js"
import style0 from "./ClassesModal.vue?vue&type=style&index=0&id=0486a2e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0486a2e6",
  null
  
)

export default component.exports